import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';

import { useNavigation } from '@react-navigation/native';

import DownIcon from '@/assets/icons/down';
import SubtractIcon from '@/assets/icons/subtract';
import RichText, { ParsedTypes } from '@/components/RichText';
import { SizedBox } from '@/components/SizedBox';
import { ds } from '@/components/lib/design.system';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { AccountTabNavigationProp } from '@/navigation/types';
import { common } from '@/styles/styles';
import { RichTextField } from '@prismicio/client';

const styles = StyleSheet.create({
    infoBox: {
        padding: 16,
        borderWidth: 1,
        borderRadius: 10,
        backgroundColor: ds.colorValue.background.neutral.subtle,
        borderColor: ds.colorValue.border.strong,
    },
    rightArrow: { marginRight: -5, transform: [{ rotate: '-90deg' }] },
});

type SelfExclusionPromptProps = {
    shouldRedirect: boolean;
};

type PromptContentProps = SelfExclusionPromptProps & {
    contentSlice: RichTextField;
};

const PromptContent = ({ shouldRedirect, contentSlice }: PromptContentProps) => {
    return (
        <View style={[common.row, common.alignCenter]}>
            <View style={[common.row, common.alignCenter]}>
                <SubtractIcon />
                <SizedBox value={20} />
            </View>
            <View style={common.flex}>
                <SizedBox value={2} />
                <View style={[common.row, common.alignCenter]}>
                    <RichText
                        data={contentSlice}
                        typeProps={{
                            [ParsedTypes.P]: {
                                color: ds.colorToken.text.primary,
                                textAlign: 'left',
                            },
                        }}
                    />
                </View>
            </View>
            {shouldRedirect ? (
                <>
                    <SizedBox value={2} />
                    <View style={[common.row, common.alignCenter]}>
                        <SizedBox value={20} />
                        <DownIcon style={styles.rightArrow} />
                    </View>
                </>
            ) : null}
        </View>
    );
};

export const SelfExclusionPrompt = ({ shouldRedirect }: SelfExclusionPromptProps) => {
    const { navigate } = useNavigation<AccountTabNavigationProp>();
    const richTextsSlices = useJurisdictionStore(state => state.jurisdictionSettings?.globalSettings?.richTextsSlices);

    const selfExclusionInfoBoxSlice = richTextsSlices?.SelfExclusionAddInfoBox || [];

    return shouldRedirect ? (
        <TouchableOpacity style={styles.infoBox} onPress={() => navigate('Timeout')}>
            <PromptContent shouldRedirect={shouldRedirect} contentSlice={selfExclusionInfoBoxSlice} />
        </TouchableOpacity>
    ) : (
        <View style={styles.infoBox}>
            <PromptContent shouldRedirect={shouldRedirect} contentSlice={selfExclusionInfoBoxSlice} />
        </View>
    );
};
